/**
 * Eluve tables that have a one-way FHIR mirror. Extend here first.
 *
 * Lives in this shared lib rather than in `@eluve/fhir-mirror` because the
 * vocabulary has three consumers that can't all reach a backend lib: the
 * mirror itself, the ts-rest admin contract (bundled into the browser), and
 * the admin page's entity list. One definition, no drift.
 */
export const FHIR_MIRROR_ENTITIES = [
  'location',
  'practitioner',
  'patient',
  // location_users assignments → per-(user, location) PractitionerRoles;
  // compound id `<userId>:<locationId>` (see userLocationIdentifierValue).
  'practitioner-role',
] as const;

export type FhirMirrorEntity = (typeof FHIR_MIRROR_ENTITIES)[number];
